<div class="u-padding-double u-flex-row u-flex-justify-content-center">
    <smvd-app-reset-password (formSubmit)="resetPassword($event)"></smvd-app-reset-password>
</div>
